import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import {computed, observable} from "mobx";
import {IGooglePlace} from "../../../../../../shared/src/model/ICoworkGeoLocation";
import { PartnersState } from "../PartnersState";
import FirebaseFunctionsService from "src/services/firebase/functions/FirebaseFunctionsService";


export class PartnersStore extends ApiCallObservable {
    @observable public files: any = {
        coveragePdfFile: ''
    };
    @observable public formInput = {};
    @observable public navigationController = {};
    @observable public isEmailValid: boolean = true;
    @observable public emailErrorMessage:  string = '';
    @observable private _location: IGooglePlace | string = '';
    @observable private _currentScreen: PartnersState = PartnersState.welcome;
    @observable private _isFormFinish: boolean = false;

    public setInputValue = (formPage: string, propertyName: string, value: any) =>  {
        this.formInput[formPage][propertyName] = value;
    };

    @computed
    get getEmailErrorMessage(){
        return this.emailErrorMessage;
    };

    get currentScreen() {
        return this._currentScreen;
    };

    get location() {
        return this._location;
    };

    get allowFinishForm() {
        return this._isFormFinish;
    };

    public updateFinishForm = (value: boolean) => {
        this._isFormFinish = value;
    };

    public updateScreen = (screen: PartnersState) => {
        this._currentScreen = screen;
    };

    public updateLocation = (selectedCowork?: IGooglePlace | string) => {
        this._location = selectedCowork? selectedCowork : '';
        this.formInput["location"] = this._location
    };

    public initState = () => {
        this.formInput = {};
        this._location = ``
    }

    public async submit() {
        try {
            this.setSending();
            const request = {
                source : "Partner",
                coworkLocation : this.location,
                fullName : this.formInput["fullName"],
                workEmail : this.formInput["workEmail"],
                phoneNumber : this.formInput["phoneNumber"],
                workspacePosition : this.formInput["workspacePosition"],
            }
            
            const response = await FirebaseFunctionsService.partnerRequest(request);
            if (response.ok && response.data) {
                this.setSuccessfulResponse(response.data);
                this.updateScreen(PartnersState.finish);
            } else {
                console.log(`Server returned error!`);
                this.updateScreen(PartnersState.finish);
            }
        } catch (err) {
            console.error(err);
            this.setError(`${err}`);
            this.updateScreen(PartnersState.finish);
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/PartnersStore.ts